import { getProjectAdminEndpoint } from 'root/src/server/modules/project/endpoints/getProjectAdmin.endpoint';
export const projectsEndpoints = Object.assign({}, getProjectAdminEndpoint);
